"use strict";

var _objectWithoutProperties = require("/app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/app/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var e = require("react");

var t = e.createContext({
  nodes: {},
  register: function register() {},
  unregister: function unregister() {},
  namespace: ""
});
exports.NodeManager = function (_ref) {
  var r = _ref.children;

  var _e$useState = e.useState({}),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      n = _e$useState2[0],
      s = _e$useState2[1],
      o = e.useRef(function () {
    return "".concat(Math.random().toString(32).substr(2, 8));
  }()),
      u = e.useCallback(function (e, t) {
    s(function (r) {
      return _objectSpread({}, r, _defineProperty({}, e, t));
    });
  }, []),
      a = e.useCallback(function (e) {
    s(function (t) {
      var r = t[e],
          n = _objectWithoutProperties(t, [e]);

      return n;
    });
  }, []),
      c = e.useMemo(function () {
    return {
      namespace: o.current,
      nodes: n,
      register: u,
      unregister: a
    };
  }, [n, u, a, o]);

  return e.createElement(t.Provider, {
    value: c
  }, r);
}, exports.useOrderedNodes = function () {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (e) {
    return e.sort(function (e, t) {
      var r = e.compareDocumentPosition(t);
      if (4 & r || 16 & r) return -1;
      if (2 & r || 8 & r) return 1;
      if (1 & r || 32 & r) throw "Cannot sort the given nodes.";
      return 0;
    });
  };

  var _e$useState3 = e.useState([]),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      n = _e$useState4[0],
      s = _e$useState4[1],
      _e$useContext = e.useContext(t),
      o = _e$useContext.nodes,
      u = _e$useContext.namespace;

  return e.useLayoutEffect(function () {
    var e = r(Object.keys(o).map(function (e) {
      return o[e];
    }));
    s(e);
  }, [o, u]), n;
}, exports.useNodes = function () {
  var _e$useContext2 = e.useContext(t),
      r = _e$useContext2.nodes;

  return r;
}, exports.useRegisteredRef = function (r) {
  var n = e.useCallback(function (e) {
    e ? s(r, e) : o(r);
  }, [r]),
      _e$useContext3 = e.useContext(t),
      s = _e$useContext3.register,
      o = _e$useContext3.unregister;

  return n;
};